

function buildCallItem(data) {
  return {
    title: data.callerid || 'Unknown',
    date: new Date(data.started),
    type: 'call',
    key: data.key,
    callKey: data.key,
    active: data.active,
    activeItem: false,
    data: {
      status: data.status ?? '',
      uniqueid: data.key.replace('@','.'),
      call_disposition_saved: data.call_disposition_saved ?? false,
      ended: data.ended ?? false
    }
  }
}

const state = {
  activeActivityCall: null,
  activeActivityCallSubscriber: null,
  callCenterRef: null
}

const getters = {
  getActiveActivityCall: state => state.activeActivityCall,
}

const mutations = {
  SET_ACTIVE_ACTIVITY_CALL:(state, call) => (state.activeActivityCall = call),
  SET_ACTIVE_ACTIVITY_CALL_REF:(state, ref) => (state.activeActivityCallRef = ref),
  SET_CALL_CENTER_REF: (state, ref) => (state.callCenterRef = ref)
}

const actions = {
  listenToCalls({ rootGetters, commit, dispatch }) {
    const user = rootGetters.getUser
    const agent = rootGetters.getAgent
    const firebase = rootGetters.getFirebase
    const organizationId = rootGetters.getOrganizationId

    if (state.callCenterRef) {
      return
    }

    const date = new Date()
    date.setMinutes(date.getMinutes() - agent.agentActivityTimeout);

    const ref = firebase.database().ref(`call_center/${user.uid}`).orderByChild('started').startAt(date.getTime())

    commit('SET_CALL_CENTER_REF', ref)

    ref.on('child_added', async (snap) => {
      let { callerid = null } = snap.val()

      if (callerid === null) {
        setTimeout(() => {
          firebase.database().ref(`organization/${organizationId}/calls`).child(snap.key).once('value', function (callSnap) {
            if (callSnap.val().callerid) {
              firebase.database().ref(`call_center/${user.uid}`).child(snap.key).update({ callerid: callSnap.val().callerid})
            }
          })
        }, 2000)
      }

      //const call = buildCallItem({key: snap.key, ...snap.val(), callerid })
      const call = buildCallItem({key: snap.key, ...snap.val() })
      commit('ADD_ACTIVITY', call, { root: true })

      if (call.active) {
        dispatch('listenToCall', call.key)
        commit('SET_ACTIVE_ITEM', call.key, { root: true })
        commit('SET_CALL_KEY_ACTIVE', call.key, { root: true })
        commit('SET_LAST_CALL_UNIQUE_ID', call.key, { root: true })
      }

    })

    ref.on('child_changed', (snap) => {
      const call = buildCallItem({key: snap.key, ...snap.val()})
      commit('UPDATE_ACTIVITY_V2', call, { root: true })
      const lastCallKey = rootGetters.getLastCallUniqueId
      if (lastCallKey && lastCallKey === snap.key && !call.active) {
        dispatch('stopListeningToActiveCall')
      }

    })

    ref.on('child_removed', (snap) => {
      commit('REMOVE_ACTIVITY', snap.key, { root: true })
    })
  },
  listenToCall({ commit, rootGetters }, key) {
    const firebase = rootGetters.getFirebase
    const organizationId = rootGetters.getOrganizationId
    const ref = firebase.database().ref(`organization/${organizationId}/calls`).child(key)
    ref.on('value', (snap) => {
      const forms = snap.val().forms ? Object.keys(snap.val().forms).map(key => ({ key, ...snap.val().forms[key] })) : []
      const integrations = snap.val().integrations ? Object.values(snap.val().integrations) : []
      const call_disposition_forms = snap.val().call_disposition_forms ? 
        Object.keys(snap.val().call_disposition_forms).map(key => {
          const form = snap.val().call_disposition_forms[key]
          form.inputs = form.inputs.map((input, index) => ({...input, index}))
          return { key, ...form }
        }) 
        : {}
      commit('SET_ACTIVE_ACTIVITY_CALL', { 
        ...snap.val(), 
        forms, 
        integrations, 
        call_disposition_forms, 
        call_disposition_values: snap.val().call_disposition_values ?? [],
        callKey: key, 
        data: { 
          callerid: snap.val().callerid || 'Unknown',
          uniqueid: key.replace('@','.')} 
        })
    })
    commit('SET_ACTIVE_ACTIVITY_CALL_REF', ref)
  },
  stopListeningToActiveCall({ state, commit }) {
    if (state.activeActivityCallSubscriber) {
      state.activeActivityCallSubscriber.off()
      commit('SET_ACTIVE_ACTIVITY_CALL_REF', null)
    }
  },
  stopListeningAgentCalls({ state, commit }) {
    if (state.callCenterRef) {
      state.callCenterRef.off()
      commit('SET_CALL_CENTER_REF', null)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
}